import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { ArticleViewModel } from './../interfaces/ArticlesViewModel';
import HtmlElementHelper from '../../../Shared/Helpers/htmlElementHelper';

@Component({
    name: 'main-component',
    template: '#main-component',
})

export default class grocerymain extends Vue {
    //data
    selected: number = -1;
    opened: number = -1;
    preopen: number | null = null;
    cart: any[] = [];
    cartWidth: string = '320px';
    fetchedData: ArticleViewModel[] = [];
    provinces: any = [];
    municipalities: any = [];
    isPreselected: boolean = false;
    selectedProvince: string; 
    selectedMunicipality: string;
    selectedArticle: number;
    defaultElements: ArticleViewModel[] = [];
    displayElements: {
        price: boolean,
        submit: boolean,
        articlesTitle: boolean
    };

    data() {
        return {
            selectedProvince: '-1',
            selectedMunicipality: '-1',
            selectedArticle: 0,
            displayElements:
            {
                price: false,
                submit: false,
                articlesTitle: false
            }

        }
    }
    
    // props
    @Prop({})
    fetchAddress: string;
    @Prop({})
    tab: string;
    @Prop({})
    sku: string;
    @Prop({})
    articleId: string;
    @Prop({})
    province: any;

    @Prop({})
    fetchDefaultArticlesAddress: string;
    
    @Prop({})
    countryName: any;

    submitDataForm(event: JQuery.SubmitEvent): void {
        /*
        let target = event.target;
        if (!target.classList.contains("buy-button"))
            target = target.parentElement;

        const id = parseInt(target.dataset.articleId);
        (<any>window).ga4Helper.onGrocerySelectItem(id);
        */

        this.$emit('submitDataForm', event);
    }

    async mounted() {

        const csqLocation = (<any>window).csqLocation;
        this.provinces = csqLocation.provinces;
        let sp = csqLocation.selectedProvince;
        let sm = csqLocation.selectedMunicipality;
        this.isPreselected = !!this.articleId && !!sp && !!sm;

        if (this.isPreselected)
        {
            this.selectedProvince = sp;
            this.selectedMunicipality = sm;

            var isProvinceValidated = this.validateProvince();
            var isMunicipalityValidated = this.validateMunicipality();

            if (isProvinceValidated && isMunicipalityValidated)
            {
                this.municipalities = this.getMunicipalitiesByProvince(this.selectedProvince);

                await this.fetchDataAsync(this.selectedProvince, this.selectedMunicipality);
                return;
            }
        }

        await this.fetchDefaultArticlesAsync(); 
    }

    updated() {

        if (this.isPreselected) {
            const targetElem = document.getElementById("full-desk-" + this.selectedArticle);
            if (targetElem)
                (targetElem as any).scrollIntoViewIfNeeded();
        }
    }

    async fetchDefaultArticlesAsync()
    {

        this.validateForm();

        if (this.defaultElements.length > 0)
        {
            this.fetchedData = this.defaultElements;
            return;
        }

        HtmlElementHelper.g_blockUI();

        const fethedArticles = await fetch(this.fetchDefaultArticlesAddress + this.countryName)
            .then(response => response.json())
            .then(data => data);

        if (fethedArticles.length > 0)
        {
            for (let i = 0; i < fethedArticles.length; i++) {
                fethedArticles[i].Description = fethedArticles[i].Description.replace(/\/n/g, "<br>");
            }

            this.fetchedData = this.defaultElements = fethedArticles;

            this.validateForm();
        }

        HtmlElementHelper.g_unBlockUI();
    }

    async filterItemsByProvinceAsync()
    {
        var isProvinceValidated = this.validateProvince();

        this.selectedMunicipality = "-1";

        if (isProvinceValidated)
            this.municipalities = this.getMunicipalitiesByProvince(this.selectedProvince);
        

        await this.fetchDefaultArticlesAsync();

    }

    async filterItemsByMunicipalityAsync()
    {
        var isMunicipalityValidated = this.validateMunicipality();

        if (!isMunicipalityValidated)
        {
            await this.fetchDefaultArticlesAsync();
            return;
        }

        await this.fetchDataAsync(this.selectedProvince, this.selectedMunicipality);

    }

    async fetchDataAsync(province: string, municipality: string): Promise<ArticleViewModel[]>
    {
        HtmlElementHelper.g_blockUI();
        
        const fethedArticles = await fetch(this.fetchAddress + this.countryName + "/" + province + "/" + municipality)
            .then(response => response.json())
            .then(data => data);

            for (let i = 0; i < fethedArticles.length; i++) {
                fethedArticles[i].Description = fethedArticles[i].Description.replace(/\/n/g, "<br>");
            }

            this.fetchedData = fethedArticles;

            let provinceName: string;
            let municipalityName: string;
            this.provinces.forEach(function (item: any) {
                if (item.Id == province) {
                    provinceName = item.Name;
                    item.Municipalities.forEach(function (item: any) {
                        if (item.Id == municipality) {
                            municipalityName = item.Name;
                        }
                    });
                }
            });

            localStorage.setItem("groceryProvince", provinceName);
            localStorage.setItem("groceryMunicipality", municipalityName);

            this.validateForm();

            
            if (this.isPreselected) {
                this.openDesk(parseInt(this.articleId));
            }

        HtmlElementHelper.g_unBlockUI();

        return fethedArticles;
    }

    getMunicipalitiesByProvince(provinceId: string): string[] | null {
        let municipalities = null;

        this.provinces.forEach(function (item: any) {
            if (item.Id == provinceId) {
                municipalities = item.Municipalities;
            }
        });

        return municipalities;
    }

    /* validation methods */

    validateProvince(): boolean {
        if (this.selectedProvince == null || this.selectedProvince == undefined)
            this.selectedProvince = "-1";

        return this.selectedProvince != "-1";
    }

    validateMunicipality(): boolean {
        if (this.selectedMunicipality == null || this.selectedMunicipality == undefined) {
            this.selectedMunicipality = "-1";
        }

        return this.selectedMunicipality != "-1";
    }

    validateForm(): boolean {
        var isProvinceValid = this.validateProvince();
        var isMunicipalityValid = this.validateMunicipality();

        if (!isProvinceValid) {
            this.municipalities = [];
        }

        if (isProvinceValid && isMunicipalityValid) {
            this.displayElements.price = true;
            this.displayElements.submit = true;
            this.displayElements.articlesTitle = true;
            return true;
        } else {
            this.displayElements.price = false;
            this.displayElements.submit = false;
            this.displayElements.articlesTitle = false;
            return false;
        }
    }

    /* end of validation methods */
    
    openDesk(targetId: number): void {
        this.selectedArticle = targetId;
    }
}